import { versions } from './config';
import { createVersionResolver } from './versionResolver';

const resolveVersion = createVersionResolver('REACT_APP_VERSION');

export { resolveVersion, versions };
